import { useGate } from 'statsig-react';

const useFeaturesGate = (feature: string) => window.FEATURE_GATES?.[feature] || useGate(feature);

export default useFeaturesGate;
